import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';

import apiGet from '@api/api-get';
import apiPost from '@api/api-post';
import apiDelete from '@api/api-delete';
import apiPut from '@api/api-put';

interface IResult {
  code: number,
  msg: string,
  result: any,
}

const EffectService = {
  // 获取用户筛选项
  getUserOption: async () => {
    const data: IResult | null = await apiGet('/mg/human_efficiency/user_option', {});
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
  // 初始化
  getInitial: async () => {
    const data: IResult | null = await apiGet('/mg/human_efficiency/user_option/initial', {});
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
  // 编辑用户筛选项
  editUserOption: async (params: any) => {
    const res: IResult | null = await apiPut('/mg/human_efficiency/user_option', params);
    return res;
  },
  // 获取公司列表
  getCompanySample: async (industryName: string) => {
    const data: IResult | null = await apiGet('/mg/human_efficiency/company_list', {
      industry: industryName,
    });
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
  // 支持效能-各行业支持效能
  supportMultiIndustry: async (params: any) => {
    const data: IResult | null = await apiGet('/mg/human_efficiency/support_efficiency/multi_industry', params);
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
  // 支持效能-支持效能时间趋势
  supportYearTrend: async (params: any) => {
    const data: IResult | null = await apiGet('/mg/human_efficiency/support_efficiency/year_trend', params);
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
  // 人员配置-行业对比
  settleMultiIndustry: async (params: any) => {
    const data: IResult | null = await apiGet('/mg/human_efficiency/staff_size/multi_industry', params);
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
  // 人员配置-时间趋势
  settleTimeTrend: async () => {
    const data: IResult | null = await apiGet('/mg/human_efficiency/staff_size/year_trend', null);
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
  // 人员配置-变化率分布
  settleRatio: async (params: any) => {
    const data: IResult | null = await apiGet('/mg/human_efficiency/staff_size/ratio_distribution', params);
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
  // 人员配置-员工构成时间趋势
  settleStaffTimeTrend: async () => {
    const data: IResult | null = await apiGet('/mg/human_efficiency/staff_size/category/year_trend', null);
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
  // 薪酬成本投入-行业对比
  costMultiIndustryRequest: async (params: any) => {
    const data: IResult | null = await apiGet('/mg/human_efficiency/payroll/cost_ratio/multi_industry', params);
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
  // 薪酬成本投入-时间趋势
  costTimeTrendRequest: async () => {
    const data: IResult | null = await apiGet('/mg/human_efficiency/payroll/cost_ratio/year_trend', null);
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
  // 薪酬成本投入-费用中的薪酬占比
  costFeeRateRequest: async () => {
    const data: IResult | null = await apiGet('/mg/human_efficiency/payroll/category/cost_ratio', null);
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
};

export default EffectService;
